<template>
  <div style="padding: 15px">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="150px"
    >
      <div class="titleh1">
        <code />基本信息
      </div>
      <el-row>
        <el-col
          :span="8"
          style="display: none"
        >
          <el-form-item label="用户编码">
            <el-input v-model="form.partyCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="商户名称"
            prop="merchantName"
          >
            <el-input
              v-model="form.merchantName"
              :disabled="disabledUser"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="partyCode == ''"
          :span="4"
          style="margin-left:10px;"
        >
          <el-button
            type="primary"
            @click="selUser"
          >
            选择用户
          </el-button>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="商户类型"
            prop="merchantType"
          >
            <el-select
              v-model="form.merchantType"
              :disabled="statusdisabled"
              placeholder="请选择商户类型"
            >
              <el-option
                label="自然人"
                value="01"
              />
              <el-option
                label="个体工商户"
                value="02"
              />
              <el-option
                label="企业商户"
                value="03"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />详细信息
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="商户简称"
            prop="detail.alias"
          >
            <el-input
              v-model="form.detail.alias"
              clearable
              placeholder="请输入商户简称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="联系人姓名"
            prop="detail.contactName"
          >
            <el-input
              v-model="form.detail.contactName"
              :disabled="statusdisabled"
              clearable
              placeholder="请输入姓名"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="联系人手机号"
            prop="detail.contactMobile"
          >
            <el-input
              v-model="form.detail.contactMobile"
              clearable
              placeholder="请输入手机号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="身份证号码"
            prop="detail.principalCertNo"
          >
            <el-input
              v-model="form.detail.principalCertNo"
              :disabled="statusdisabled"
              clearable
              placeholder="请输入身份证号码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="身份证有效期" prop="detail.personCertVld">
            <el-date-picker
              v-model="form.detail.personCertVld"
              :class="form.hasDueDate?'disabledhide':''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox v-model="form.hasDueDate" @change="(value)=>{this.$set(form.detail,'personCertVld' , value?'9999-12-31':'');}" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="省"
            prop="detail.province"
          >
            <el-select
              v-model="form.detail.province"
              clearable
              placeholder="请选择省"
              @change="cityChange(form.detail.province)"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="市"
            prop="detail.city"
          >
            <el-select
              v-model="form.detail.city"
              clearable
              placeholder="请选择市"
              @change="districtChage(form.detail.city)"
            >
              <el-option
                v-for="item in cityList"
                :key="item.cityCode"
                :label="item.cityName"
                :value="item.cityCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="县/区"
            prop="detail.district"
          >
            <el-select
              v-model="form.detail.district"
              clearable
              placeholder="请选择县/区"
            >
              <el-option
                v-for="item in districtList"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item
            label="详细地址"
            prop="detail.address"
          >
            <el-input
              v-model="form.detail.address"
              clearable
              placeholder="请输入详细地址"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="10"
        >
          <el-form-item
            label="信用代码"
            prop="detail.bussAuthNum"
          >
            <el-input
              v-model="form.detail.bussAuthNum"
              clearable
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item prop="detail.certPhotoA">
            <ImgUpload
              :upload-config="{ lebal: '身份证国徽面照片', prefix: 'certPhotoA', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="detail.certPhotoB">
            <ImgUpload
              :upload-config="{ lebal: '身份证人像面照片', prefix: 'certPhotoB', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '03'"
          :span="8"
        >
          <el-form-item prop="detail.contractPhoto">
            <ImgUpload
              :upload-config="{ lebal: '租赁协议', prefix: 'contractPhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.licensePhoto">
            <ImgUpload
              :upload-config="{ lebal: '营业执照图片', prefix: 'licensePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.shopPhoto">
            <ImgUpload
              :upload-config="{ lebal: '店铺门头照', prefix: 'shopPhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.shopEntrancePhoto">
            <ImgUpload
              :upload-config="{ lebal: '门店内景照片', prefix: 'shopEntrancePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType == '03'"
          :span="8"
        >
          <el-form-item prop="detail.industryLicensePhoto">
            <ImgUpload
              :upload-config="{ lebal: '开户许可证照片', prefix: 'industryLicensePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />银行信息
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="账户类型"
            prop="card.accountType"
          >
            <el-select
              v-model="form.card.accountType"
              :disabled="statusdisabled"
              placeholder="请选择账户类型"
            >
              <el-option
                label="对私账户（自然人、个体工商户可选）"
                value="01"
              />
              <el-option
                label="对公账户（企业类型才可选填写）"
                value="02"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="银行卡号"
            prop="card.bankCardNo"
          >
            <el-input
              v-model="form.card.bankCardNo"
              clearable
              placeholder="请输入银行卡"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.card.accountType == '02'"
          :span="8"
        >
          <el-form-item
            label="联行号"
            prop="card.contactLine"
          >
            <el-input
              v-model="form.card.contactLine"
              clearable
              placeholder="请输入联行号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-checkbox
              v-model="checked"
              disabled
            >
              我已阅读并同意
            </el-checkbox>
            <div style="color:#606266;display:inline-block" @click="orderContract()">《网商银行订单账款管理服务合同》</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-button
        v-if="getLimit('PlatformMerchant_add_button') && form.status == null"
        type="primary"
        @click="addClick('form')"
      >
        确定
      </el-button>
      <el-button
        v-if="getLimit('PlatformMerchant_openBalPay_button') && form.openBalancePay == 0 && form.status == 2"
        type="primary"
        @click="openBalPay()"
      >
        开通余额支付权限
      </el-button>
      <el-button
        v-if="getLimit('PlatformMerchant_openMerchant_button') && form.openTradeDeposit == 0 && form.status == 2"
        type="primary"
        @click="openMerchant()"
      >
        开通保证金子户
      </el-button>
      <el-button
        v-if="getLimit('PlatformMerchant_openPrepay_button') && form.openPrepay == 0 && form.status == 2"
        type="primary"
        @click="openClick()"
      >
        开通合并支付子户
      </el-button>
    </el-form>
    <vxe-modal
      v-model="vardel"
      width="800"
      height="80%"
      title="选择用户"
      resize
    >
      <Selectuser
        v-if="vardel"
        ref="ShipperlRef"
        @event1="receive"
      />
    </vxe-modal>
  </div>
</template>
<script>
import {
  addNewBusinesses,
  bigAreaProvince,
  bigAreaCity,
  bigAreaCounty,
  openBalancePay,
  createAccount,
  mybankMerchantDetails
} from "@/api/InternetBanking";

import ImgUpload from "@/components/ImgUpload";
import Selectuser from "../MerchantNanagement/components/components/Selectuser.vue";
import {
  validatePhone,
  validateIDNumber,
} from "@/utils/validate.js";
import { isBusinessLicenseImgNum, isBankCardNum } from '@/utils/validate4Form'
export default {
  name: "MerchantManagementAdd",
  components: {
    ImgUpload,
    Selectuser
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      checked: true,
      disabledUser: false,
      statusdisabled: false,
      vardel: false,
      distrue: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      platformName:'',
      form: {
        partyCode: "",
        merchantName: "",
        merchantType: "01",
        detail: {
          alias: "",
          contactName: "",
          contactMobile: "",
          province: "",
          city: "",
          district: "",
          address: "",
          principalCertNo: "",
          certPhotoA: "",
          certPhotoB: "",
          contractPhoto: "",
          bussAuthNum: "",
          licensePhoto: "",
          shopPhoto: "",
          shopEntrancePhoto: "",
          industryLicensePhoto: "",
          personCertVld: ""
        },
        card: {
          bankCardNo: "",
          accountType: "01",
          contactLine: ""
        }
      },
      partyCode: "",
      acctType: "TRADE_DEPOSIT",
      rules: {
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符' }
        ],
        merchantType: [
          { required: true, message: "请选择商户类型", trigger: "change" }
        ],
        detail: {
          certPhotoA: [
            {
              required: true,
              message: "请选择负责人身份证国徽面",
              trigger: "blur"
            }
          ],
          certPhotoB: [
            {
              required: true,
              message: "请选择负责人身份证人像面",
              trigger: "blur"
            }
          ],
          contractPhoto: [
            { required: true, message: "请选择租赁协议", trigger: "blur" }
          ],
          licensePhoto: [
            { required: true, message: "请选择营业执照", trigger: "blur" }
          ],
          shopPhoto: [
            { required: true, message: "请选择门头照片", trigger: "blur" }
          ],
          shopEntrancePhoto: [
            { required: true, message: "请选择店内时景照", trigger: "blur" }
          ],
          industryLicensePhoto: [
            { required: true, message: "请选择开户许可照", trigger: "blur" }
          ],
          alias: [
            { required: true, message: "请输入商户简称", trigger: "blur" },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符' }
          ],
          contactName: [
            {
              required: true,
              validator(rule, value, callback) {
                // eslint-disable-next-line
                /^[\u4e00-\u9fa5\·]+$/.test(value)
                  ? callback()
                  : callback(new Error("请输入联系人姓名(仅支持汉字)"));
              }
            }
          ],
          contactMobile: [
            {
              required: true,
              validator(rule, value, callback) {
                validatePhone(value)
                  ? callback()
                  : callback(new Error("请输入正确的手机号"));
              }
            }
          ],
          province: [
            { required: true, message: "请选择省", trigger: "change" }
          ],
          city: [{ required: true, message: "请选择市", trigger: "change" }],
          district: [
            { required: true, message: "请选择县区", trigger: "change" }
          ],
          address: [
            { required: true, message: "请输入详细地址", trigger: "blur" },
            { max: 255, message: "最大长度为255个字符"}
          ],
          principalCertNo: [
            {
              required: true,
              validator(rule, value, callback) {
                validateIDNumber(value)
                  ? callback()
                  : callback(new Error("请输入正确的身份证号"));
              }
            }
          ],
          bussAuthNum: [
            {
              required: true,
              message: "请输入统一社会信用代码",
              trigger: "blur"
            },
            { validator: isBusinessLicenseImgNum }
          ],
          personCertVld: [
            { required: true, message: "请选择身份证有效期", trigger: "change" }
          ]
        },
        card: {
          bankCardNo: [
            {
              required: true,
              message: "请输入银行卡号",
              trigger: "blur"
            },
            { validator: isBankCardNum }
          ],
          accountType: [
            { required: true, message: "请选择账户类型", trigger: "change" }
          ],
          contactLine: [
            { required: true, message: "请输入联行号", trigger: "blur" },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符' }
          ]
        }
      }
    };
  },
  created() {
    this.platformName = localStorage.getItem("platformName") || '网络货运平台';
    this.bigProvince();
    if (this.form.partyCode == "") {
      this.distrue = true;
    }
    if (
      typeof JSON.parse(localStorage.getItem('dataBranch')).mybankPlatformPartCode ==
      "undefined"
    ) {
      this.partyCode = "";
    } else {
      this.partyCode = JSON.parse(
        localStorage.getItem('dataBranch')
      ).mybankPlatformPartCode;
      this.disabledUser = true;
      this.MerchantEditor();
    }
  },
  methods: {
     orderContract(){
        window.open(this.BASE_API_URL + "agreement/agreement.html?agreementType=15",'_blank')
    },
    //详情
    MerchantEditor() {
      const rLoading = this.openLoading();
      mybankMerchantDetails(this.partyCode).then(response => {
        rLoading.close();
        this.form = response.data;
        this.$set(this.form, "hasDueDate", this.form.detail.personCertVld=='9999-12-31')
        this.cityChange(this.form.detail.province);
        this.districtChage(this.form.detail.city);
        this.$emit("event2");
        if (this.form.status > 0 && this.form.status < 4) {
          this.statusdisabled = true;
        }
      });
    },
    //提交
    addClick(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          addNewBusinesses(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("event2");
          });
        } else {
          return false;
        }
      });
    },
    Reset() {
      this.$refs.form.resetFields();
    },
    selUser() {
      this.vardel = true;
    },
    receive(a) {
      if (a&&a.getdata) {
        this.form.partyCode = a.getdata.code;
        this.form.merchantName = a.getdata.name;
        this.form.detail.alias = a.getdata.name;
      }
      if (a&&a.partyData) {
        this.form.detail.contactName = a.partyData.name;
        this.form.detail.contactMobile = a.partyData.phone;
        this.form.detail.province = a.partyData.provinceCode;
        this.form.detail.city = a.partyData.cityCode;
        this.form.detail.district = a.partyData.countyCode;
        this.form.detail.address = a.partyData.homeAddress;
        this.form.detail.principalCertNo = a.partyData.identificationNumber;
        this.form.detail.certPhotoA = a.partyData.identificationImg;
        this.form.detail.certPhotoB = a.partyData.identificationBackImg;
        this.cityChange(this.form.detail.province);
        this.districtChage(this.form.detail.city);
      }
      if (a && a.bankCardData ) {
        this.form.card.bankCardNo = a.bankCardData.account;
        this.form.card.accountType = "0" + a.bankCardData.type;
        this.form.card.contactLine = a.bankCardData.contactLine;
      }
      this.vardel = false;
      this.distrue = false;
    },
    //开通余额支付权限
    openBalPay() {
      openBalancePay(this.partyCode).then(response => {
        this.$message({ message: response.msg, type: "success" });
      });
    },
    //开通保证金子户
    openMerchant() {
      createAccount(this.acctType, this.partyCode).then(response => {
        this.$message({ message: response.msg, type: "success" });
      });
    },
    //开通合并支付子户
    openClick() {
      this.acctType = "PREPAY";
      createAccount(this.acctType, this.partyCode).then(response => {
        this.$message({ message: response.msg, type: "success" });
      });
    },
    //省
    bigProvince() {
      bigAreaProvince().then(response => {
        this.provinceList = response.data.records;
      });
    },
    //市
    cityChange(a) {
      bigAreaCity({ provinceCode: a }).then(response => {
        this.cityList = response.data.records;
      });
    },
    districtChage(b) {
      bigAreaCounty({ cityCode: b }).then(response => {
        this.districtList = response.data.records;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
</style>
